import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { SalesOrderOutline } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 1265. 以前のプロジェクト候補プロジェクト（売上）一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/target_prev_sales_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const targetPrevSalesOrders = (props: Props): Promise<SalesOrderOutline[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/target_prev_sales_orders`
  );
};

export const useTargetPrevSalesOrders = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => targetPrevSalesOrders(props),
  });
};

export const useInvalidateTargetPrevSalesOrders = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) }).then((r) => {});
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'target_prev_sales_orders'];
};
